<template>
    <b-card class="my-3 shadow-sm">
        <b-card-text>
            <!-- Display question body and choices. Display value if evaluated -->
            <b-container fluid>
                <b-row no-gutters :class="{ 'pb-3': !selectedSurveyObject.isEvaluated }">
                    <b-col cols="12">
                        <h5 class="display-breaks text-justify"><strong>{{ number }}.</strong> {{ question.body }}</h5>
                    </b-col>
                </b-row>

                <b-row v-if="selectedSurveyObject.isEvaluated" no-gutters>
                    <b-col cols="11" offset="1">
                        <p>
                            Ponderación: <strong>{{ question.valueDisplay }} %</strong>
                        </p>
                    </b-col>
                </b-row>

                <!-- Choices Section Row -->
                <b-row
                    v-for="choice in question.choices"
                    :key="`choice-${choice.id}`"
                    class="mb-3"
                >
                    <b-col sm="11" offset-sm="1" align-self="center">
                        <b-form-radio
                            v-if="question.answerType === 'simple'"
                            v-model="selected"
                            :name="`question-${question.id}`"
                            :value="choice.id"
                            @change="onUpdateAnswer()"
                        >
                            {{ choice.body }}
                        </b-form-radio>

                        <b-form-checkbox
                            v-if="question.answerType === 'multiple'"
                            v-model="selected"
                            :name="`question-${question.id}`"
                            :value="choice.id"
                            @change="onUpdateAnswer()"
                        >
                            {{ choice.body }}
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-container>
        </b-card-text>
    </b-card>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
    name: 'SurveyQuestion',
    props: {
        question: Object,
        number: Number
    },
    data () {
        return {
            selected: []
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedSurveyObject'
        ]),
        choices () {
            return this.question.choices.map((choice) => {
                return { text: choice.body, value: choice.id }
            })
        }
    },
    methods: {
        ...mapActions([
            'updateStudentSurveyAnswer'
        ]),
        onUpdateAnswer: debounce(async function () {
            try {
                let selectedChoicesIds = []
                if (Array.isArray(this.selected)) {
                    selectedChoicesIds = this.selected
                } else {
                    selectedChoicesIds.push(this.selected)
                }
                var payload = {
                    courseSiteId: this.activeSite.id,
                    studentSurveyId: this.selectedSurveyObject.studentSurvey.id,
                    surveyId: this.selectedSurveyObject.id,
                    surveyQuestionId: this.question.id,
                    selectedChoicesJsonIds: JSON.stringify(selectedChoicesIds)
                }
                await this.updateStudentSurveyAnswer(payload)
            } catch (err) {
                console.log(err)
                this.$root.dangerToast('No se puedo actualizar su respuesta, intente más tarde o recargue la página.')
            }
        }, 400)
    },
    created () {
        if (this.question.selectedChoicesIds.length) {
            switch (this.question.answerType) {
            case 'simple':
                this.selected = this.question.selectedChoicesIds[0]
                break
            case 'multiple':
                this.selected = this.question.selectedChoicesIds
                break
            }
        }
    }
}
</script>
